/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/swap_medium'
export default icon
